export default {
  skeletonsLabel: {
    id: 'asp_action_bar_actions_list_step_loading_skeleton_label',
    defaultMessage: 'Loading',
  },
}
